import * as accountReportList from './list';
import * as listVehiclesDetailWaitHappy from './detail';
import * as dowloadAccountReportWait from './excel';
const Reducers = {
  ...accountReportList,
  ...listVehiclesDetailWaitHappy,
  ...dowloadAccountReportWait,
};

export default Reducers;
